import { PipelineType } from "pages/pipelines"
import React from "react"
import getPipelinePublicUrl from "../services/getPipelinePublicUrl"
import { Alert, AlertTitle, Box, List, ListItem, ListItemText } from "@mui/material"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

interface PipelineDeployListProps {
  selectedPipelines: PipelineType[]
  pipelineIds: number[]
  diffKeys?: {
    diffKeys: string[]
    pipelineId: number
  }[]
  alert?: boolean
  error?: boolean
}

const PipelineDeployList = ({
  selectedPipelines,
  pipelineIds,
  diffKeys,
  alert,
  error,
}: PipelineDeployListProps) => {
  if (!pipelineIds.length) return null

  const renderList = () => {
    return selectedPipelines.map((pipeline) => {
      const publicUrl = getPipelinePublicUrl(pipeline)
      const pipelineName = publicUrl.toString().replace(/^.*:\/\//, "")

      if (pipelineIds.includes(pipeline.id)) {
        const pipeDiffKeys = diffKeys
          ? diffKeys.find((diff) => diff.pipelineId === pipeline.id)
          : null
        return (
          <>
            {pipeDiffKeys && (
              <Accordion key={pipeline.id}>
                <AccordionSummary sx={{ my: 1 }} expandIcon={<ExpandMoreIcon />}>
                  <div style={{ width: "100%" }}>
                    <Alert severity={error ? "error" : alert ? "warning" : "success"}>
                      {pipelineName}
                    </Alert>
                  </div>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                  <Box mx={4} fontSize={12} pb={1}>
                    {pipeDiffKeys?.diffKeys &&
                      pipeDiffKeys.diffKeys.map((diffKey, index) => {
                        return <div key={`diff-key-${index}`}>{diffKey}</div>
                      })}
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}
            {!pipeDiffKeys && (
              <ListItem key={pipeline.id} sx={{ py: 0 }}>
                <ListItemText>
                  <span>
                    <Alert severity={error ? "error" : alert ? "warning" : "success"}>
                      {pipelineName}
                    </Alert>
                  </span>
                </ListItemText>
              </ListItem>
            )}
          </>
        )
      }
    })
  }

  return (
    <>
      {error && (
        <Alert severity="error">
          <AlertTitle>Error!</AlertTitle>
          Pipelines cannot be deployed!
        </Alert>
      )}
      {alert && (
        <Alert severity="warning">
          <AlertTitle>Warning!</AlertTitle>
          Pipelines have missing translation keys! Missing keys will have default translations!
        </Alert>
      )}
      <List sx={{ maxHeight: 300, overflow: "auto" }}>{renderList()}</List>
    </>
  )
}

export default PipelineDeployList
